import { useNavigate } from "react-router-dom";
import { NavCardProps } from "../types/prop.navcard";

export const useQIProjectMenuItems = (): Array<NavCardProps> => {
    const navigate = useNavigate();
    const QIProjectMenuItems: Array<NavCardProps> = [
        {
            title: "New Project",
            icon: "add",
            onClick: () => {
              navigate('create-project');
            },
        },
        {
            title: "Existing",
            icon: "folder",
            onClick: () => {
                navigate("qi-project/existing-projects")
            },
        },
        
    ];

    return QIProjectMenuItems;
};
export default useQIProjectMenuItems;